import axios from "axios";

import { API_URL, MARKETING_API_URL, PEOPLE_API_URL, CRM_API_URL } from "../Config/index.js";


// User Login API
export const userLogin = async (requestPayload) => {
  try {
    const response = await axios.post(
      `${API_URL}/user-auth/login/1`,
      requestPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  } catch (error) {
    console.log("Login error:", error);
    return error;
  }
};

export const userGoogleLogin = async (token, phoneNumber = null, source = null) => {
  try {
    let payload = { token };

    // Only include phoneNumber in payload if it's provided
    if (phoneNumber) {
      payload.phoneNumber = phoneNumber;
    }

    // Only include source in payload if it's provided
    if (source) {
      payload.source = source;

    }

    let baseUrl = API_URL;
    if (source === "marketingSotware") {
      baseUrl = MARKETING_API_URL;
    }
    else if (source === "peopleSoftware") {
      baseUrl = PEOPLE_API_URL;
      payload = { googleToken: token };
    }
    else if (source === "crmSoftware") {
      baseUrl = CRM_API_URL;
    }

    const response = await axios.post(
      `${baseUrl}/user-auth/OAuth2Client/login`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  } catch (error) {
    console.log("Google login error:", error);
    return error;
  }
};

